export const titles = ["Mr", "Mrs", "Ms", "Miss"];

export const GenderType = ["Male", "Female"];

export const StatusList = [{ value: 'Confirmed', label: 'Confirmed' }];

export const RateType = { clientNetSell: 'ClientNetSell', contractBuy: 'ContractBuy' };

export const ReservationType = {
    hotel: 'hotel',
    service: 'service',
    transfer: 'transfer'
};

export const ServiceType = {
    single: 'Single',
    unit: 'Unit'
};

export const HotelMessageLevel = {
    hotelLevel: 'hotelLevel',
    roomLevel: 'roomLevel'
};

export const childrenCount = 17;

export const childAge = 18;

export const Age_Options = Array.from({ length: 18 }, (_, i) => i);

export const ReservationStatus = {
    Confirmed: 'Confirmed',
    Waitlisted: 'WaitListed',
    Cancelled: 'Cancelled',
};

export const chatConstants = {
    USER_ROLE: 'user',
    ASSISTANT_ROLE: 'assistant',
    SCROLL_BEHAVIOR: 'smooth',
    ENTER_KEY: 'Enter',
    TIME_FORMAT_OPTIONS: {
        hour: '2-digit',
        minute: '2-digit'
    },
    MESSAGE_BUBBLE_STYLES: {
        MAX_WIDTH: '70%',
        AVATAR_SIZE: 36,
        BORDER_RADIUS: {
            USER: '16px 16px 4px 16px',
            ASSISTANT: '16px 16px 16px 4px'
        }
    }
};

export const screenSize = {
    smallScreenSize: 1366,
    largeScreenSize: 1920
};

export const mrtViewReservationTableColumnSize = {
    smallSize: 92.5,
    largeSize: 120
};

export const mrtMyReservationTableColumnSize = {
    smallSize: 120,
    largeSize: 155
};

export const voucherTypes = {
    hotel: {
        title: "Hotel Voucher",
        itemsKey: "Rooms",
        itemMapper: (room) => ({ ...room, type: ReservationType.hotel })
    },
    service: {
        title: "Service Voucher",
        itemsKey: "Items",
        itemMapper: (item) => ({ ...item, type: ReservationType.service })
    }
};

export const defaultAdultAge = 18;

export const exchangeRate = {
    ContractCurrency: "LKR",
    ClientCurrency: "USD"
};

export const productTypes = [
  { value: 'Hotel', label: 'Hotel' },
  { value: 'Service', label: 'Service' },
];

export const providerTypes = [
  { value: 'OkloV1', label: 'Oklo' },
  { value: 'Illusions', label: 'Illusions' },
];

export const markupCriteriaTypes = {
  Agent: 'Agent',
  Country: 'Country',
};

export const Route_Type_Config = {
    arrival: { label: 'Arrival', color: '#1565c0', bg: '#e3f2fd', border: '#edeff1' },
    intermediate: { label: 'Transfer', color: '#6a1b9a', bg: '#f3e5f5', border: '#edeff1' },
    departure: { label: 'Departure', color: '#2e7d32', bg: '#e8f5e9', border: '#edeff1' },
};

export const typeOrder = ['arrival', 'intermediate', 'departure'];

export const adultOptions = Array.from({ length: 50 }, (_, index) => index + 1);

export const childrenOptions = Array.from({ length: 11 }, (_, index) => index);

export const defaultTransferPassengers = { adults: 2, children: [] };

export const state = {
    Active: 'Active',
    Inactive: 'Inactive'
};

